import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Modal,
  Row,
  Table,
} from 'reactstrap';
import { CircularProgress } from '@material-ui/core';

import formatCurrency from 'utils/formatCurrency';
import { PropostaVersao } from 'models/PropostaVersao';
import { useContext, useEffect, useState } from 'react';
import api from 'services/api';
import { PropostaVersaoParcelas } from 'models/PropostaVersaoParcelas';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBr from 'date-fns/locale/pt-BR';
import { FaCalculator, FaPlusCircle, FaTrash } from 'react-icons/fa';
import arredondaCentesimal from 'utils/arredondaCentesimal';
import { Th, Td } from './styles';
import { PropostaContext } from '../..';
import Parcelas from '../Precificacao/components/Parcelas';
import { iPropostaDados } from '../Precificacao';

registerLocale('pt-BR', ptBr);

interface Resultados {
  propostaVersao: PropostaVersao;
  apenasSintetica: boolean;
}

interface ResultadoSintetica {
  conta: string;
  valor: number;
  percentualROL: number;
  limitar: boolean;
}

interface ResultadoAnalitica {
  item: string;
  valor: number;
  percentualROL: number;
  percentualROB: number;
  limitar: boolean;
}

interface ResultadoVisaoPorAtividade {
  codigoAtividade: string;
  descricaoAtividade: string;
  bdiTotal: number;
  precoBruto: number;
  precoLiquido: number;
  custoMateriais: number;
  percentualROL: number;
  demaisCV: number;
  margemCont: number;
  percentualMargemROL: number;
  abcFat: number;
  isTotalRow: boolean;
}

interface iPropostaVersaoParcelas {
  id: number;
  meioPagamentoId: number;
  dataPrevista?: Date | null | string;
  percentual: number;
  valor: number;
  observacao: string;
}

/**
 *
interface iPropostaVersaoParcelas extends PropostaVersaoParcelas {
  dias?: number;
  calculo?: number;
}
*/

interface iAcessoPrograma {
  programa: number;
  acessoLimitado: boolean;
  temAcesso: boolean;
}

// 80 Proposta - Analisador - Editar Data Embarque
// 81 Proposta - Analisador - Editar Juros
// 82 Proposta - Analisador - Editar Dias Data Juros
// 83 Proposta - Analisador - Visualização completa de tabelas

export default function Resultados({
  propostaVersao,
  apenasSintetica,
}: Resultados): JSX.Element {
  const { carregaPropostaVersao, meioPagamentos } = useContext(PropostaContext);

  const [resultadoSintetica, setResultadoSintetica] = useState<
    ResultadoSintetica[]
  >([]);
  const [resultadoAnalitica, setResultadoAnalitica] = useState<
    ResultadoAnalitica[]
  >([]);
  const [resultadoAtividade, setResultadoAtividade] = useState<
    ResultadoVisaoPorAtividade[]
  >([]);
  const [isLoadingSintetica, setIsLoadingSintetica] = useState(false);
  const [isLoadingAnalitica, setIsLoadingAnalitica] = useState(false);
  const [isLoadingAtividade, setIsLoadingAtividade] = useState(false);
  const [isLoadingPrazoMedio, setIsLoadingPrazoMedio] = useState(false);
  const [recalcularCustoFinanceiro, setRecalcularCustoFinanceiro] =
    useState(false);

  const [valoresDiferentes, setValoresDiferentes] = useState(false);

  const [precisaSalvar, setPrecisaSalvar] = useState(false);

  const [tabelasLimitadas, setTabelasLimitadas] = useState(false);

  const [isAtingirMeta, setIsAtingirMeta] = useState(false);

  const [dadosBasicosCarregados, setDadosBasicosCarregados] = useState(false);

  const [acessoProgramas, setAcessosProgramas] = useState<iAcessoPrograma[]>(
    [] as iAcessoPrograma[],
  );
  const [custoFinanceiro, setCustoFinanceiro] = useState(0);
  const [jurosMensal, setJurosMensal] = useState(0);
  const [diasSomar, setDiasSomar] = useState(0);
  const [diasAntesEmbarque, setDiasAntesEmbarque] = useState(0);
  const [diasParaEmbarque, setDiasParaEmbarque] = useState(0);
  const [PMR, setPMR] = useState(0);
  const [dataEmbarque, setDataEmbarque] = useState<any>();
  const [dataBaseJurosEmbarque, setDataBaseJurosEmbarque] = useState<string>();
  const [isSaving, setIsSaving] = useState(false);

  const [metaDesconto, setMetaDesconto] = useState(
    propostaVersao?.desconto ?? 0,
  );
  const [metaValor, setMetaValor] = useState(
    formatCurrency(propostaVersao?.valorFinal ?? 0, 2),
  );
  const [metaEbitda, setMetaEbitda] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [descontoMaximo, setDescontoMaximo] = useState<number | null>(null);

  const [propostaVersaoParcelas, setPropostaVersaoParcelas] = useState<any[]>(
    [],
  );

  const [isModoSimulacao, setIsModoSimulacao] = useState(false);
  const [parcelasModificadas, setParcelasModificadas] = useState(false);
  const [custoChanged, setCustoChanged] = useState(false);

  const [informacaoProposta, setInformacaoProposta] =
    useState<iPropostaDados>();

  function quaseIgual(a: number, b: number, tolerancia = 0.00001) {
    console.log(a, b, Math.abs(a - b), Math.abs(b - a));
    if (b > a) return Math.abs(b - a) <= tolerancia;
    return Math.abs(a - b) <= tolerancia;
  }

  async function handleChange(newObject: iPropostaDados) {
    console.log({
      a: 'analisador',
      newObject,
    });

    // setPropostaVersaoParcelas(newObject.parcelas);

    /**
     *

    const novoObj: iPropostaDados = {
      ...newObject,
      parcelas: propostaVersaoParcelas
    }
    */
    setInformacaoProposta(newObject);
    // sempre que houver mudanças aqui, vou desabilitar o botão de salvar. O usuário precisa calcular primeiro
    // setEnableSaveButton(false);
  }

  async function buscarListaDescontos() {
    if (!propostaVersao) return;

    const response2 = await api.get(
      `/proposta-perfil-aprovacao/min-max-desconto/${propostaVersao.id}`,
    );

    setDescontoMaximo(response2.data?.descontoMaximo ?? 0);
  }

  async function carregarDadosSintetica() {
    try {
      setIsLoadingSintetica(true);
      const metaValorValue = Number(
        String(metaValor ?? '0')
          .replace('R$', '')
          .trim()
          .replaceAll('.', '')
          .replaceAll(',', '.'),
      );
      const response = await api.get(
        `/proposta-resultado/sintetica?versaoId=${propostaVersao.id}&isAtingirMeta=${isAtingirMeta}&custoModificado=${custoChanged}&novoCusto=${custoFinanceiro}&metaValor=${metaValorValue}`,
      );

      setResultadoSintetica(response.data as ResultadoSintetica[]);
      return response.data as ResultadoSintetica[];
    } finally {
      setIsLoadingSintetica(false);
    }
  }

  async function carregarDadosAnalitica() {
    try {
      setIsLoadingAnalitica(true);
      const metaValorValue = Number(
        String(metaValor ?? '0')
          .replace('R$', '')
          .trim()
          .replaceAll('.', '')
          .replaceAll(',', '.'),
      );
      const response = await api.get(
        `/proposta-resultado/analitica?versaoId=${propostaVersao.id}&isAtingirMeta=${isAtingirMeta}&custoModificado=${custoChanged}&novoCusto=${custoFinanceiro}&metaValor=${metaValorValue}`,
      );

      setResultadoAnalitica(response.data as ResultadoAnalitica[]);
    } finally {
      setIsLoadingAnalitica(false);
    }
  }

  async function carregarDadosAtividade() {
    try {
      setIsLoadingAtividade(true);
      const metaValorValue = Number(
        String(metaValor ?? '0')
          .replace('R$', '')
          .trim()
          .replaceAll('.', '')
          .replaceAll(',', '.'),
      );
      const response = await api.get(
        `/proposta-resultado/atividade?versaoId=${propostaVersao.id}&isAtingirMeta=${isAtingirMeta}&custoModificado=${custoChanged}&novoCusto=${custoFinanceiro}&metaValor=${metaValorValue}`,
      );

      setResultadoAtividade(response.data as ResultadoVisaoPorAtividade[]);
    } finally {
      setIsLoadingAtividade(false);
    }
  }

  async function carregarDadosBasicos() {
    setDadosBasicosCarregados(false);
    const response = await api.get(
      `/proposta-resultado/prazo-medio?versaoId=${propostaVersao.id}`,
    );

    const vDataEmbarque = new Date(
      `${String(response.data.dataEmbarque).split('T')[0]}T10:10:10`,
    );

    vDataEmbarque.toLocaleDateString('pt-BR', {
      timeZone: 'UTC',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });

    const vDataJuros = new Date(vDataEmbarque);

    vDataJuros.setDate(
      vDataJuros.getDate() - (response.data.diasAntesEmbarque ?? 0),
    );

    const diferenca = new Date(vDataEmbarque).getTime() - new Date().getTime();

    let diferencaFinal = 0;

    if (diferenca > 0) diferencaFinal = diferenca / (1000 * 3600 * 24);

    const dataE = `${vDataEmbarque.getFullYear()}-${String(
      vDataEmbarque.getMonth() + 1,
    ).padStart(2, '0')}-${String(vDataEmbarque.getDate()).padStart(2, '0')}`;

    const dataJ = vDataJuros.toLocaleDateString('pt-BR', {
      timeZone: 'UTC',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });

    setPrecisaSalvar(response.data.existemDados === false);
    setDataBaseJurosEmbarque(dataJ);
    setDiasParaEmbarque(Math.ceil(diferencaFinal));
    setDataEmbarque(new Date(`${dataE}T10:10:10`));
    setJurosMensal(response.data.jurosMensal ?? 0);
    setDiasAntesEmbarque(response.data.diasAntesEmbarque ?? 0);
    setDiasSomar(response.data.diasSomar ?? 0);
    setDadosBasicosCarregados(true);
  }

  async function getAcessoPrograma() {
    const response = await api.get('/acesso-programa/acesso-programa-lote', {
      params: {
        programas: [80, 81, 82, 83],
      },
    });

    const lista = response.data as iAcessoPrograma[];

    const acessoLimitadoTabela = !lista.find(
      item =>
        item.programa === 83 &&
        item.temAcesso === true &&
        item.acessoLimitado === false,
    );

    setTabelasLimitadas(acessoLimitadoTabela);

    setAcessosProgramas(lista);
    // setAcessoPrograma(response.data);
  }

  async function dadosProposta() {
    const response = await api.get(
      `/proposta-precificacao/versao/${propostaVersao.id}`,
    );

    const proposta = response.data as iPropostaDados;

    setInformacaoProposta(proposta);
  }

  function formatarParcelas(parcelasArr: any[]) {
    return parcelasArr.map((parcelaVal: any) => {
      return {
        id: parcelaVal.id,
        meioPagamentoId: parcelaVal.meioPagamentoId,
        dataPrevista: parcelaVal.dataPrevista ?? null,
        percentual: parcelaVal.percentual ?? 0,
        valor: parcelaVal.valor ?? 0,
        observacao: parcelaVal.observacao ?? '',
      };
    });
  }

  useEffect(() => {
    getAcessoPrograma();
  }, []);

  /**
   *
  async function carregarParcelas() {
    const response = await api.get(
      `/proposta/versao/${propostaVersao.id}/parcelas`,
    );
    setPropostaVersaoParcelas(response.data as iPropostaVersaoParcelas[]);
    setParcelasModificadas(false);
  }
  */

  async function calcularParcelas(dataEmb: string, filtro = 0) {
    const parcelas = informacaoProposta?.parcelas ?? [];
    // const parcelas = propostaVersaoParcelas;

    if (!dataEmb) return [];

    return parcelas
      ?.filter(
        (item: any) =>
          item.meioPagamentoId === (filtro > 0 ? filtro : item.meioPagamentoId),
      )
      ?.map((item: iPropostaVersaoParcelas) => {
        let diferencaCalcular = 0;

        if (!item.dataPrevista || !dataEmb) diferencaCalcular = 0;
        else {
          const diferenca =
            new Date(
              `${String(item.dataPrevista).split('T')[0]}T10:10:10`,
            ).getTime() - new Date(dataEmb).getTime();

          if (diferenca <= 0) diferencaCalcular = 0;
          else diferencaCalcular = diferenca / (1000 * 3600 * 24);
        }

        const diferencaFinal = Math.floor(diferencaCalcular);

        const divisorFormatado = Number(item.percentual ?? 0) / 100;

        return Math.floor(diferencaFinal * divisorFormatado);
      });
  }

  async function calcularCusto(
    paramJurosMensal: number,
    parcelasCalculadas: number[],
  ): Promise<{
    custo: number;
    pmr: number;
  }> {
    const totalSomaProduto =
      parcelasCalculadas.reduce(
        // eslint-disable-next-line prettier/prettier
        (tot: number, item: number) => tot + item * 100,
        0,
      ) / 100;

    const calculoPMR = totalSomaProduto;

    // const calculoPMR =
    //   totalValorParcelas === (precoBruto?.valor ?? 0) ? totalSomaProduto : 0;

    //= 1*(1+N25)^(P27/30)-1
    const calculoCustoFin =
      1 * (1 + (paramJurosMensal ?? 0) / 100) ** (calculoPMR / 30) - 1;

    const custoFinanceiroFinal = arredondaDecimais(calculoCustoFin * 100, 2);

    return {
      custo: custoFinanceiroFinal,
      pmr: calculoPMR,
    };
  }

  async function carregarDadosPrazoMedio(
    paramJurosMensal: number,
    paramDiasAntesEmbarque: number,
    paramDataBase?: string | null,
  ) {
    setIsLoadingPrazoMedio(true);

    if (!paramDataBase || !paramDataBase) return;

    const isParalelo = propostaVersao.meioPagamentoId === 4;
    // const isParalelo = true;

    if (isParalelo) {
      const parcelasCalculadasRP = await calcularParcelas(paramDataBase, 1);
      const parcelasCalculadasF = await calcularParcelas(paramDataBase, 2);

      const resultCustoRP = await calcularCusto(
        paramJurosMensal ?? 0,
        parcelasCalculadasRP,
      );
      const resultCustoF = await calcularCusto(
        paramJurosMensal ?? 0,
        parcelasCalculadasF,
      );

      const objeto =
        resultCustoRP.custo >= resultCustoF.custo
          ? resultCustoRP
          : resultCustoF;

      console.log(resultCustoF, resultCustoRP);
      setCustoFinanceiro(objeto.custo);
      setPMR(objeto.pmr);
    } else {
      const parcelasCalculadas = await calcularParcelas(paramDataBase);
      const resultCusto = await calcularCusto(
        paramJurosMensal ?? 0,
        parcelasCalculadas,
      );
      setCustoFinanceiro(resultCusto.custo);
      setPMR(resultCusto.pmr);
    }

    setJurosMensal(paramJurosMensal ?? 0);
    setDiasAntesEmbarque(paramDiasAntesEmbarque ?? 0);
    setRecalcularCustoFinanceiro(false);

    const vDataEmbarque = new Date(paramDataBase);
    const vDataJuros = new Date(paramDataBase);

    vDataJuros.setDate(vDataJuros.getDate() - (paramDiasAntesEmbarque ?? 0));

    const diferenca = new Date(vDataEmbarque).getTime() - new Date().getTime();

    let diferencaFinal = 0;

    if (diferenca > 0) diferencaFinal = diferenca / (1000 * 3600 * 24);

    const dataJuro = vDataJuros.toLocaleDateString('pt-BR', {
      timeZone: 'UTC',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });

    setDataEmbarque(paramDataBase);
    setDiasParaEmbarque(Math.ceil(diferencaFinal));
    setDataBaseJurosEmbarque(dataJuro);
    setIsLoadingPrazoMedio(false);
  }

  function atualizarDados(propriedade: string, valor: any) {
    if (propriedade === 'dias_antes_embarque') {
      carregarDadosPrazoMedio(jurosMensal, Number(valor ?? 0), dataEmbarque);
    } else if (propriedade === 'juros_mensal') {
      carregarDadosPrazoMedio(
        Number(valor ?? 0),
        diasAntesEmbarque,
        dataEmbarque,
      );
    } else if (propriedade === 'data_embarque') {
      if (!Number.isNaN(Date.parse(valor)))
        carregarDadosPrazoMedio(jurosMensal, diasAntesEmbarque, valor);
    }
    setCustoChanged(true);
    setPrecisaSalvar(true);
  }

  async function carregarDadosGerais() {
    await carregarDadosSintetica();
    await carregarDadosAnalitica();
    await carregarDadosAtividade();
  }

  useEffect(() => {
    dadosProposta();
    // carregarParcelas();
    buscarListaDescontos();
    carregarDadosBasicos();
    carregarDadosGerais();
  }, []);

  useEffect(() => {
    if (
      dadosBasicosCarregados === true &&
      informacaoProposta &&
      informacaoProposta.parcelas.length > 0 &&
      resultadoSintetica &&
      resultadoSintetica.length > 0
    ) {
      const totalParcela =
        informacaoProposta.parcelas.reduce(
          (total: number, registro: any) =>
            // eslint-disable-next-line prettier/prettier
            total + ((registro.valor ?? 0) * 100),
          0,
        ) / 100;

      const totalSintentica =
        resultadoSintetica.find(item => item.conta === 'Receita Bruta')
          ?.valor ?? 0;

      const quase = quaseIgual(totalSintentica, totalParcela);

      let parcelasDiferentes = totalParcela !== totalSintentica && !quase;

      console.log({
        quase,
        totalSintentica,
        totalParcela,
        a: informacaoProposta.parcelas.map((item: any) => item.valor),
      });

      const isParalelo = propostaVersao.meioPagamentoId === 4;

      if (isParalelo) {
        const totalRP = informacaoProposta.parcelas
          ?.filter(item => item.meioPagamentoId === 1)
          .reduce((acc, it) => acc + (it.valor ?? 0), 0);

        const totalF = informacaoProposta.parcelas
          ?.filter(item => item.meioPagamentoId === 2)
          .reduce((acc, it) => acc + (it.valor ?? 0), 0);

        console.log({ totalRP, totalSintentica, totalF });

        parcelasDiferentes =
          totalRP !== totalSintentica || totalF !== totalSintentica;
      }

      setValoresDiferentes(parcelasDiferentes);
    }
  }, [
    resultadoSintetica,
    informacaoProposta?.parcelas,
    dadosBasicosCarregados,
  ]);

  useEffect(() => {
    if (
      dadosBasicosCarregados === true &&
      informacaoProposta &&
      informacaoProposta.parcelas.length > 0 &&
      resultadoSintetica &&
      resultadoSintetica.length > 0 &&
      !resultadoSintetica.find(item => item.conta === 'Ebitda 2')
    ) {
      if (jurosMensal && dataEmbarque) {
        carregarDadosPrazoMedio(jurosMensal, diasAntesEmbarque, dataEmbarque);
      }
    }
  }, [
    resultadoSintetica,
    informacaoProposta?.parcelas,
    dadosBasicosCarregados,
  ]);

  useEffect(() => {
    if (recalcularCustoFinanceiro === true) {
      if (jurosMensal && dataEmbarque) {
        carregarDadosPrazoMedio(jurosMensal, diasAntesEmbarque, dataEmbarque);
      }
    }
  }, [recalcularCustoFinanceiro]);

  async function checkAprovacaoDescontoNecessaria() {
    const descontoSalvar = Number(
      String(metaDesconto ?? '0').replaceAll(',', '.') ?? 0,
    );

    if (descontoSalvar > Number(descontoMaximo ?? 0)) {
      const valor = await Swal.fire({
        title: `Desconto precisa de aprovação`,
        html: `<div style='text-align: justify!important; text-justify: inter-word;'>
            O percentual informado (${descontoSalvar}%) excede o máximo permitido (<u>menor que</u> ${descontoMaximo}%) para o perfil.
            <br /><br />Ao prosseguir, o efetivo uso desse percentual passará por uma aprovação.
            A proposta ficará bloqueada enquanto aguarda uma resposta dos aprovadores.
            <br /><br />Você será informado por e-mail caso seja aprovado ou reprovado. Deseja prosseguir?</div>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, prosseguir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      });
      return { aprovacao: true, salvar: valor.isConfirmed };
    }

    return { aprovacao: false, salvar: true };
  }

  async function handleUpdateDescontoSelecionado(descontoEnviar: string) {
    const descontoSalvar = Number(descontoEnviar?.replaceAll(',', '.') ?? 0);

    Swal.fire({
      icon: 'info',
      text: `Atualizando o desconto`,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
    try {
      const retorno = await api.put(`/proposta/versao/${propostaVersao.id}`, {
        desconto: descontoSalvar,
      });

      return retorno.data;
    } catch (error: any) {
      let mensagem = error?.response?.data?.message;

      if (!mensagem) {
        mensagem = error?.message;
      }
      console.log(mensagem ?? 'Não foi possível salvar o desconto');
      throw error;
    }
  }

  async function processoSalvarDesconto() {
    try {
      let salvarDesconto: { aprovacao: boolean; salvar: boolean } = {
        aprovacao: false,
        salvar: false,
      };

      salvarDesconto = await checkAprovacaoDescontoNecessaria();

      // let recalcular = true;
      if (salvarDesconto.salvar) {
        await handleUpdateDescontoSelecionado(String(metaDesconto ?? 0));

        Swal.fire({
          icon: 'info',
          text: `Recalculando proposta`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });
        // Dispara processo para recalcular, após salvar.
        await api.post(`/proposta/versao/${propostaVersao.id}/recalcular`, {
          isAtingirMeta,
        });
      }

      carregaPropostaVersao();
      Swal.close();
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        text: error?.response?.data?.message,
      });
    }
  }

  async function salvarValoresPrazoMedio(podeDispararAprovacao = false) {
    /**
     *
    if (parcelasModificadas) {
      // Percorrer as parcelas e validar elas antes de salvar.

      const parcelasIncompletas = informacaoProposta?.parcelas.filter(
        (item: any) =>
        !item.meioPagamentoId ||
        !item.percentual ||
        !item.dataPrevista ||
        !item.observacao,
      );

      if (parcelasIncompletas && parcelasIncompletas.length > 0) {
        Swal.fire({
          icon: 'error',
          title: 'Ops!',
          html: 'Um ou mais registros da lista de parcelas estão incompletos. Todos são obrigatórios.',
        });
        return;
      }
    }
    */

    const valor = await Swal.fire({
      title: `Substituir valores salvos`,
      html: `<div style='text-align: justify!important; text-justify: inter-word;'>
          As informações de Data de Embarque, Dias da Base de Juros e Juros irão sobrescrever os valores salvos anteriormente para a proposta.
          ${
            isModoSimulacao
              ? `<br /><br /><strong>Você está em modo de simulação. Ao salvar, o percentual de desconto indicado será aplicado em toda a proposta. </strong><br />`
              : ``
          }

          <br /><br /><strong>Se houve modificação nas parcelas. Ao salvar, as parcelas que foram definidas no Analisador passarão a ser as válidas na proposta.</strong><br />

          <br />Deseja prosseguir?</div>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: `Sim, prosseguir`,
      confirmButtonColor: '#d33',
      cancelButtonText: `Não`,
    });

    if (valor.isConfirmed) {
      try {
        // Colocar o processo para salvar
        setIsSaving(true);

        Swal.fire({
          icon: 'info',
          text: `Salvando informações...`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        const metaValorValue = Number(
          String(metaValor ?? '0')
            .replace('R$', '')
            .trim()
            .replaceAll('.', '')
            .replaceAll(',', '.'),
        );

        // buscar comissão
        const comissao =
          resultadoAnalitica.find(item => item.item === 'Comissão Calculada')
            ?.percentualROB ?? 0;

        const retorno = await api.put(`/proposta-resultado/salvar-analisador`, {
          propostaVersaoId: propostaVersao.id,
          jurosMensal,
          diasAntesEmbarque,
          dataEmbarque,
          custoFinanceiro,
          PMR,
          parcelas: informacaoProposta?.parcelas ?? [],
          parcelasModificadas: !informacaoProposta?.aprovacao.parcelaAprovada,
          metaValor: metaValorValue,
          isAtingirMeta,
          metaDesconto,
          podeDispararAprovacao,
          comissao,
          descontoModificado: metaDesconto !== (propostaVersao?.desconto ?? 0),
          parcelaAprovada:
            informacaoProposta?.aprovacao.parcelaAprovada ?? false,
        });

        const temAprovacao = retorno.data.possuiAprovacao as boolean;

        if (temAprovacao) {
          const valorRetorno = await Swal.fire({
            title: `Aprovações necessárias`,
            html: `<div style='text-align: justify!important; text-justify: inter-word;'>
                  <p>Algumas informações estão fora do permitido. Sendo necessárias passarem por fluxo de aprovação:</p>
                  ${retorno.data.mensagem ?? ''}
                  <br /><br /><p>Deseja prosseguir com o salvamento?</p></div>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `Sim, prosseguir`,
            confirmButtonColor: '#d33',
            cancelButtonText: `Não`,
          });

          if (valorRetorno.isConfirmed) {
            await salvarValoresPrazoMedio(true);
          }
        } else {
          // await carregarParcelas();
          setIsModoSimulacao(false);
          carregaPropostaVersao();
          toast.success('Informações salvas com sucesso');
        }

        // toast.success('Informações salvas com sucesso');
        setIsSaving(false);
        setPrecisaSalvar(false);
        Swal.close();
      } finally {
        setIsSaving(false);
      }
    }
  }

  async function handleCalcularSimulador(tipo: string) {
    const atingirMeta = tipo === 'V';
    const isEbitdaMeta = tipo === 'E';
    setIsLoading(true);
    setIsLoadingSintetica(true);
    setRecalcularCustoFinanceiro(false);
    setIsLoadingAnalitica(true);
    setIsLoadingAtividade(true);
    const toastId = toast.loading('Calculando...');
    try {
      let descontoCalcular = metaDesconto;
      let percentMetaEbitda = 0;

      if (tipo === 'R') {
        descontoCalcular = propostaVersao?.desconto ?? 0;
      }

      if (tipo === 'E') {
        // Rodar o cálculo do ebitda para obter o percentual
        const response = await api.post(`/proposta-resultado/calcular`, {
          propostaVersaoId: propostaVersao.id,
          percentual: metaEbitda ?? 0,
          custoModificado: true,
          novoCusto: custoFinanceiro,
          tipo: 'E',
        });

        descontoCalcular = response.data.percentual ?? 0;
        percentMetaEbitda = response.data.metaEbitda;
        setMetaDesconto(descontoCalcular);

        if (descontoCalcular === 0) {
          Swal.fire({
            title: `Ebitda`,
            html: `<div style='text-align: justify!important; text-justify: inter-word;'>
                Não foi possível encontrar um desconto que gerasse o ebitda solicitado</div>`,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#d33',
          });
          return;
        }
      }

      // acha o desconto
      if (tipo === 'V') {
        setIsAtingirMeta(true);
        // Rodar o cálculo do ebitda para obter o percentual
        const response = await api.post(`/proposta-resultado/calcular`, {
          propostaVersaoId: propostaVersao.id,
          isAtingirMeta: atingirMeta,
          custoModificado: true,
          novoCusto: custoFinanceiro,
          metaValor,
          percentual: Number(
            String(metaValor ?? '0')
              .replace('R$', '')
              .trim()
              .replaceAll('.', '')
              .replaceAll(',', '.'),
          ),
          tipo: 'V',
        });

        descontoCalcular = response.data.percentual ?? 0;
        // setMetaDesconto(descontoCalcular);
      }

      // conseguiu atingir a meta corretamente
      const responseAt = await api.post(`/proposta-resultado/calcular`, {
        propostaVersaoId: propostaVersao.id,
        isAtingirMeta: atingirMeta,
        custoModificado: true,
        novoCusto: custoFinanceiro,
        percentual: descontoCalcular,
        percentMetaEbitda,
        isEbitdaMeta: false,
        metaValor: Number(
          String(metaValor ?? '0')
            .replace('R$', '')
            .trim()
            .replaceAll('.', '')
            .replaceAll(',', '.'),
        ),
        tipo: 'D',
        calculo: 'AT',
      });

      if (atingirMeta) {
        descontoCalcular = responseAt.data.desconto ?? 0;
        setMetaDesconto(descontoCalcular);
      }

      setResultadoAtividade(
        responseAt.data.retorno as ResultadoVisaoPorAtividade[],
      );

      // conseguiu atingir a meta corretamente
      const responseS = await api.post(`/proposta-resultado/calcular`, {
        propostaVersaoId: propostaVersao.id,
        isAtingirMeta: atingirMeta,
        percentual: descontoCalcular,
        custoModificado: true,
        novoCusto: custoFinanceiro,
        percentMetaEbitda,
        isEbitdaMeta: false,
        metaValor: Number(
          String(metaValor ?? '0')
            .replace('R$', '')
            .trim()
            .replaceAll('.', '')
            .replaceAll(',', '.'),
        ),
        tipo: 'D',
        calculo: 'S',
      });

      const dadosSint = responseS.data as ResultadoSintetica[];
      setResultadoSintetica(dadosSint);

      // conseguiu atingir a meta corretamente
      const responseA = await api.post(`/proposta-resultado/calcular`, {
        propostaVersaoId: propostaVersao.id,
        isAtingirMeta: atingirMeta,
        percentual: descontoCalcular,
        custoModificado: true,
        novoCusto: custoFinanceiro,
        percentMetaEbitda,
        isEbitdaMeta: false,
        metaValor: Number(
          String(metaValor ?? '0')
            .replace('R$', '')
            .trim()
            .replaceAll('.', '')
            .replaceAll(',', '.'),
        ),
        tipo: 'D',
        calculo: 'A',
      });

      setResultadoAnalitica(responseA.data as ResultadoAnalitica[]);

      // get parcelas

      const tPropostaParcelas = informacaoProposta?.parcelas ?? [];
      // const tPropostaParcelas = propostaVersaoParcelas;

      // Pega o novo valor
      const valor =
        dadosSint.find(item => item.conta === 'Receita Bruta')?.valor ?? 0;

      const valorTotal = valor; // Total da proposta

      const isComFinanciamento = propostaVersao.meioPagamentoId === 3;

      const recursoProprioTotal = isComFinanciamento
        ? tPropostaParcelas.reduce(
            (acc, it) =>
              acc +
              (meioPagamentos.find(
                item => item.financiado && item.id === it.meioPagamentoId,
              )
                ? 0
                : (valorTotal * (it.percentual ?? 0)) / 100),
            0,
          )
        : 0;

      const novoValorTotal = valorTotal - recursoProprioTotal;

      const parcelasNovo: iPropostaVersaoParcelas[] = tPropostaParcelas.map(
        it => {
          return {
            ...it,
            valor: meioPagamentos.find(
              item => item.financiado && item.id === it.meioPagamentoId,
            )
              ? (novoValorTotal * (it.percentual ?? 0)) / 100
              : (valorTotal * (it.percentual ?? 0)) / 100,
          };
        },
      );

      console.log(parcelasNovo);

      // setPropostaVersaoParcelas(parcelasNovo);

      const parcelasFormatadas = formatarParcelas(parcelasNovo);
      if (informacaoProposta) {
        const novaPropostaValores: iPropostaDados = {
          ...informacaoProposta,
          parcelas: parcelasFormatadas,
          valores: {
            ...informacaoProposta.valores,
            valorFinal: valorTotal,
          },
        };

        handleChange(novaPropostaValores);
        /**
         *
        setInformacaoProposta({
          ...informacaoProposta,
          parcelas: parcelasFormatadas,
          valores: {
            ...informacaoProposta.valores,
            valorFinal: valorTotal,
          },
        });
        */
      }

      setRecalcularCustoFinanceiro(true);

      toast.success('Cálculo concluído');
    } catch (e: any) {
      console.log(e);
    } finally {
      toast.dismiss(toastId);
      setIsLoadingAtividade(false);
      setIsLoadingAnalitica(false);
      setIsLoadingSintetica(false);
      setIsLoading(false);
    }
  }

  async function handleSimulationMode(open: boolean) {
    if (open) {
      setIsModoSimulacao(open);
    } else {
      const valor = await Swal.fire({
        title: `Sair modo simulação`,
        html: `<div style='text-align: justify!important; text-justify: inter-word;'>
            Você está no modo de simulação. Quaisquer alterações serão perdidas. A tela será atualizada para mostrar os dados originais. Deseja prosseguir?</div>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, prosseguir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      });

      if (valor.isConfirmed) {
        setIsModoSimulacao(false);

        setMetaDesconto(propostaVersao?.desconto ?? 0);
        setMetaValor(formatCurrency(propostaVersao?.valorFinal ?? 0, 2));
        setMetaEbitda(0);

        // await carregarParcelas();
        await carregarDadosBasicos();
        await handleCalcularSimulador('R');
      }
    }
  }

  /*
  function handleRemoverParcela(parcela: any) {
    const objMax =
      propostaVersaoParcelas && propostaVersaoParcelas.length > 0
        ? propostaVersaoParcelas?.reduce((max, curren) =>
            max.id > curren.id ? max : curren,
          )
        : null;

    const valFinalCentavos = Math.round(
      (propostaVersao?.valorFinal ?? 0) * 100,
    );

    const ocorrenciaDoValor = propostaVersaoParcelas.filter(
      item => item.meioPagamentoId === parcela.meioPagamentoId,
    );

    const newArrayParcelas = propostaVersaoParcelas.filter(
      item => item.id !== parcela.id,
    );

    const parcelasRecursoProprio = newArrayParcelas
      .filter(item => item.meioPagamentoId === 1)
      .map(item => {
        return {
          ...item,
          valor: Math.round((valFinalCentavos * (item?.percentual ?? 0)) / 100),
        };
      });

    const newValorSemRecursoProprio =
      valFinalCentavos -
      parcelasRecursoProprio.reduce((acc, it) => acc + it.valor, 0);

    const parcelasFinanciamento = newArrayParcelas
      .filter(item => item.meioPagamentoId === 2)
      .map(item => {
        return {
          ...item,
          valor: Math.round(
            (newValorSemRecursoProprio * (item?.percentual ?? 0)) / 100,
          ),
        };
      });

    if (
      propostaVersao.meioPagamentoId === 3 &&
      ocorrenciaDoValor.length === 1
    ) {
      if (ocorrenciaDoValor[0].meioPagamentoId === 1) {
        parcelasRecursoProprio.push({
          id: (objMax?.id ?? 0) + 1,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          propostaVersaoId: propostaVersao.propostaVersaoId,
          meioPagamentoId: 1,
          dataPrevista: null,
          percentual: 0,
          valor: 0,
          observacao: '',
        });
      } else {
        parcelasRecursoProprio.push({
          id: (objMax?.id ?? 0) + 2,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          propostaVersaoId: propostaVersao.propostaVersaoId,
          meioPagamentoId: 2,
          dataPrevista: null,
          percentual: 0,
          valor: 0,
          observacao: '',
        });
      }
    } else if (
      propostaVersao.meioPagamentoId === 1 &&
      ocorrenciaDoValor.length === 1
    ) {
      parcelasRecursoProprio.push({
        id: (objMax?.id ?? 0) + 2,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        propostaVersaoId: propostaVersao.propostaVersaoId,
        meioPagamentoId: 1,
        dataPrevista: null,
        percentual: 0,
        valor: 0,
        observacao: '',
      });
    } else if (
      propostaVersao.meioPagamentoId === 2 &&
      ocorrenciaDoValor.length === 1
    ) {
      parcelasRecursoProprio.push({
        id: (objMax?.id ?? 0) + 2,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        propostaVersaoId: propostaVersao.propostaVersaoId,
        meioPagamentoId: 2,
        dataPrevista: null,
        percentual: 0,
        valor: 0,
        observacao: '',
      });
    }

    const parcelasEmCentavos = [
      ...parcelasRecursoProprio,
      ...parcelasFinanciamento,
    ];

    const parcelasEmReais = parcelasEmCentavos.map(item => ({
      ...item,
      valor: +(item.valor / 100).toFixed(2), // transforma em reais
    }));

    // setPropostaVersaoParcelas(parcelasEmReais);

    const parcelasFormatadas = formatarParcelas(parcelasEmReais);
    if (informacaoProposta) {
      const novaPropostaValores: iPropostaDados = {
        ...informacaoProposta,
        parcelas: parcelasFormatadas,
      };

      handleChange(novaPropostaValores);
    }

    setParcelasModificadas(true);
    setRecalcularCustoFinanceiro(true);
  }
  */

  /**
   *
  function handleRemoverParcela(parcela: iPropostaVersaoParcelas) {
    console.log({
      propostaVersaoParcelas,
      parcela,
    });
    setPropostaVersaoParcelas(
      propostaVersaoParcelas.filter(item => item.id !== parcela.id),
    );
    setParcelasModificadas(true);
    setRecalcularCustoFinanceiro(true);
  }
  */

  /**
   *
  function handleAdicionarParcela(meioPagamentoId: number) {
    if (!meioPagamentoId) return;
    const objMax =
      propostaVersaoParcelas && propostaVersaoParcelas.length > 0
        ? propostaVersaoParcelas?.reduce((max, curren) =>
            max.id > curren.id ? max : curren,
          )
        : null;

    // const parcelasFormatadas = formatarParcelas(parcelasNovo);
    if (informacaoProposta) {
      const novasParcelas = [
        ...informacaoProposta?.parcelas,
        {
          id: (objMax?.id ?? 0) + 1,
          propostaVersaoId: propostaVersao.id,
          meioPagamentoId,
          dataPrevista: null,
          percentual: null,
          valor: 0,
          observacao: '',
        },
      ];
      const novaPropostaValores: iPropostaDados = {
        ...informacaoProposta,
        parcelas: novasParcelas,
      };

      handleChange(novaPropostaValores);
    }

    setPropostaVersaoParcelas([
      ...propostaVersaoParcelas,
      {
        id: (objMax?.id ?? 0) + 1,
        propostaVersaoId: propostaVersao.id,
        meioPagamentoId,
        dataPrevista: null,
        percentual: null,
        valor: 0,
        observacao: '',
      },
    ]);
    setParcelasModificadas(true);
  }

  function handleChangeValueRecurso(
    parcelaId: number,
    name: string,
    value: number | string,
    habilitaFinanciamento: boolean,
  ) {
    const isComFinanciamento = propostaVersao.meioPagamentoId === 3;

    //    const valorTotalProposta = precoBruto?.valor ?? 0;
    const valorTotalProposta = resultadoAnalitica[0]?.valor ?? 0;

    const percentual =
      name === 'percentual'
        ? {
            valor: arredondaDecimais(
              (Number(value) * valorTotalProposta) / 100,
              2,
            ),
          }
        : {};

        const novaPropostaVersaoParcelas = propostaVersaoParcelas.map(
      propostaVersaoParcela =>
        propostaVersaoParcela.id === parcelaId
      ? {
        ...propostaVersaoParcela,
        ...percentual,
        [name]: name === 'percentual' ? Number(value ?? 0) : value,
      }
      : propostaVersaoParcela,
    );

    if (isComFinanciamento) {
      // Atualiza os valoresGerais

      // Busca o que tem de recurso próprio
      const recursoProprio = novaPropostaVersaoParcelas
        .filter(item => item.meioPagamentoId === 1)
        .reduce(
          (acc, it) => acc + (valorTotalProposta * (it.percentual ?? 0)) / 100,
          0,
        );

        const totalParcelas = valorTotalProposta - recursoProprio;

        const novaLista = novaPropostaVersaoParcelas.map(
          (propostaVersaoParcela: any) => {
            if (propostaVersaoParcela.meioPagamentoId === 1)
            return propostaVersaoParcela;

            const valorUsar =
            (totalParcelas * propostaVersaoParcela.percentual) / 100;

            return {
              ...propostaVersaoParcela,
              valor: arredondaDecimais(valorUsar, 2),
            };
          },
        );

        setPropostaVersaoParcelas(novaLista);
      } else {
        setPropostaVersaoParcelas(novaPropostaVersaoParcelas);
    }
    setParcelasModificadas(true);
    setRecalcularCustoFinanceiro(true);
    setCustoChanged(true);
  }
  */

  async function recalcularCusto() {
    setIsLoading(true);

    const isComFinanciamento = propostaVersao.meioPagamentoId === 3;

    const toastId = toast.loading('Calculando...');

    const dadosSint = await carregarDadosSintetica();
    await carregarDadosAnalitica();
    await carregarDadosAtividade();

    const tPropostaParcelas = informacaoProposta?.parcelas ?? [];

    // Pega o novo valor
    const valor =
      dadosSint.find(item => item.conta === 'Receita Bruta')?.valor ?? 0;

    const valorTotal = valor; // Total da proposta

    const recursoProprioTotal = isComFinanciamento
      ? tPropostaParcelas.reduce(
          (acc, it) =>
            acc +
            (meioPagamentos.find(
              item => item.financiado && item.id === it.meioPagamentoId,
            )
              ? 0
              : (valorTotal * (it.percentual ?? 0)) / 100),
          0,
        )
      : 0;

    const novoValorTotal = valorTotal - recursoProprioTotal;

    console.log(valorTotal);

    const parcelasNovo: iPropostaVersaoParcelas[] = tPropostaParcelas.map(
      it => {
        return {
          ...it,
          valor: meioPagamentos.find(
            item => item.financiado && item.id === it.meioPagamentoId,
          )
            ? (novoValorTotal * (it.percentual ?? 0)) / 100
            : (valorTotal * (it.percentual ?? 0)) / 100,
        };
      },
    );

    // setPropostaVersaoParcelas(parcelasNovo);
    const parcelasFormatadas = formatarParcelas(parcelasNovo);
    if (informacaoProposta) {
      const novaPropostaValores: iPropostaDados = {
        ...informacaoProposta,
        parcelas: parcelasFormatadas,
        valores: {
          ...informacaoProposta.valores,
          valorFinal: valorTotal,
        },
      };

      handleChange(novaPropostaValores);
    }
    setIsLoading(false);
    setCustoChanged(false);
    toast.dismiss(toastId);
  }

  /**
   *

  function criaMeioPagamento(meioPagamento: iPropostaVersaoParcelas[]) {
    return (
      <>
        <Row style={{ width: '100%' }} className="mt-4">
          <Col sm="6">
            <strong>
              {meioPagamento?.[0]?.meioPagamento?.descricao ?? ''}
            </strong>
          </Col>
          <Col sm="6">
            <Button
              outline
              className="btn btn-default float-right"
              title="Adicionar Parcela"
              type="button"
              color="default"
              size="sm"
              hidden={!isModoSimulacao}
              onClick={() =>
                handleAdicionarParcela(meioPagamento?.[0]?.meioPagamentoId ?? 0)
              }
            >
              <FaPlusCircle />
            </Button>
          </Col>
        </Row>
        <Table
          responsive
          bordered
          className="mt-2"
          style={{ tableLayout: 'fixed', width: '100%' }}
        >
          <colgroup>
            <col style={{ width: `${isModoSimulacao ? 10 : 20}%` }} />
            <col style={{ width: `20%` }} />
            <col style={{ width: `20%` }} />
            <col style={{ width: `20%` }} />
            <col style={{ width: `20%` }} />
            <col hidden={!isModoSimulacao} style={{ width: `10%` }} />
          </colgroup>
          <thead>
            <tr>
              <Th>Dias</Th>
              <Th>Data</Th>
              <Th>%</Th>
              <Th>Valor</Th>
              <Th>Evento</Th>
              <Th hidden={!isModoSimulacao} />
            </tr>
          </thead>
          <tbody>
            {meioPagamento.map((parcela, index) => {
              const { id, dataPrevista, observacao, percentual, valor } =
                parcela;

              const dataParcelaPrevista = `${
                String(dataPrevista)?.split('T')[0]
              }T21:00:00`;

              let diferencaDias = 0;
              if (!dataPrevista || !dataEmbarque) diferencaDias = 0;
              else {
                const diferenca =
                  new Date(dataPrevista).getTime() -
                  new Date(dataEmbarque).getTime();

                if (diferenca <= 0) diferencaDias = 0;
                else diferencaDias = diferenca / (1000 * 3600 * 24);
              }
              const dataPrevistaSemHora = String(dataPrevista)?.split('T')[0];

              return (
                <tr key={index}>
                  <Td className="text-right">
                    <Label className="pt-3 pr-4 text-muted">
                      <strong>{Math.ceil(diferencaDias)}</strong>
                    </Label>
                  </Td>
                  <Td className="text-right">
                    <Label className="pt-3 pr-4 text-muted">
                      {isModoSimulacao ? (
                        <Input
                          type="date"
                          value={dataPrevistaSemHora}
                          onChange={event =>
                            handleChangeValueRecurso(
                              id,
                              'dataPrevista',
                              event.target.value,
                              false,
                            )
                          }
                        />
                      ) : (
                        <strong>
                          {new Date(dataParcelaPrevista).toLocaleDateString()}
                        </strong>
                      )}
                    </Label>
                  </Td>
                  <Td className="text-right">
                    <Label className="pt-3 pr-4 text-muted">
                      {isModoSimulacao ? (
                        <InputGroup className="input-group-alternative">
                          <Input
                            type="number"
                            value={String(percentual)}
                            onChange={event => {
                              // setHabilitaFinanciamento(false);
                              handleChangeValueRecurso(
                                id,
                                'percentual',
                                event.target.value,
                                false,
                              );
                            }}
                          />
                          <InputGroupAddon addonType="append">
                            %
                          </InputGroupAddon>
                        </InputGroup>
                      ) : (
                        <strong>{percentual}%</strong>
                      )}
                    </Label>
                  </Td>
                  <Td className="text-right">
                    <Label className="pt-3 pr-4 text-muted">
                      <strong>{formatCurrency(valor, 2)}</strong>
                    </Label>
                  </Td>
                  <Td>
                    <Label className="pt-3 pr-4 text-muted">
                      {isModoSimulacao ? (
                        <Input
                          value={String(observacao)}
                          onChange={event =>
                            handleChangeValueRecurso(
                              id,
                              'observacao',
                              String(event.target.value),
                              false,
                            )
                          }
                        />
                      ) : (
                        <p
                          style={{
                            whiteSpace: 'pre-wrap',
                            wordWrap: 'break-word',
                          }}
                        >
                          {observacao}
                        </p>
                      )}
                    </Label>
                  </Td>
                  <Td hidden={!isModoSimulacao}>
                    <InputGroup className="mt-2 pl-3 pr--1">
                      <Button
                        outline
                        className="btn-icon btn-2 ml-1"
                        color="danger"
                        type="button"
                        title="Remover Parcela"
                        size="sm"
                        onClick={() => handleRemoverParcela(parcela)}
                      >
                        <FaTrash />
                      </Button>
                    </InputGroup>
                  </Td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <Td className="text-right" colSpan={3}>
                <Label className="pt-3 pr-4 text-muted">
                  <strong>
                    {arredondaDecimais(
                      meioPagamento.reduce(
                        (total: number, registro: any) =>
                          // eslint-disable-next-line prettier/prettier
                          total + (registro.percentual ?? 0),
                        0,
                      ),
                    )}
                    %
                  </strong>
                </Label>
              </Td>
              <Td className="text-left">
                <Label className="pt-3 pr-4 text-muted">
                  <strong>
                    Total:{' '}
                    {formatCurrency(
                      meioPagamento.reduce(
                        (total: number, registro: any) =>
                          // eslint-disable-next-line prettier/prettier
                          total + (registro.valor ?? 0) * 100,
                        0,
                      ) / 100,
                      2,
                    )}
                  </strong>
                </Label>
              </Td>
              <Td colSpan={isModoSimulacao ? 2 : 1} />
              <td />
            </tr>
          </tfoot>
        </Table>
      </>
    );
  }
  */

  /**
   *
  function criarTabela(propostaVersaoParcelasArg: iPropostaVersaoParcelas[]) {
    const recursoProprio = propostaVersaoParcelasArg.filter(
      parc => parc.meioPagamentoId === 1,
    );
    const financiamento = propostaVersaoParcelasArg.filter(
      parc => parc.meioPagamentoId === 2,
    );

    const tabelas: JSX.Element[] = [];
    if (recursoProprio.length > 0) {
      tabelas.push(criaMeioPagamento(recursoProprio));
    }

    if (financiamento.length > 0) {
      tabelas.push(criaMeioPagamento(financiamento));
    }

    return tabelas;
  }
  */

  return (
    <>
      <Card className="shadow mt-1 mb-1">
        <CardBody>
          {
            // {apenasSintetica === true}
          }
          {apenasSintetica === false && (
            <>
              <Row className="ml-1">
                <Col sm="8">
                  <Button
                    size="sm"
                    className="btn-icon"
                    color="info"
                    type="button"
                    hidden={isModoSimulacao}
                    disabled={isSaving}
                    onClick={() => handleSimulationMode(!isModoSimulacao)}
                  >
                    <span className="btn-inner--text">
                      Iniciar Modo Simulação
                    </span>
                  </Button>
                  <Button
                    size="sm"
                    className="btn-icon"
                    color="danger"
                    type="button"
                    hidden={!isModoSimulacao}
                    disabled={isSaving}
                    onClick={() => handleSimulationMode(!isModoSimulacao)}
                  >
                    <span className="btn-inner--text">Cancelar Simulação</span>
                  </Button>
                </Col>
                <Col sm="4">
                  <Button
                    size="sm"
                    className="btn-icon float-right mr-0"
                    color="warning"
                    type="button"
                    // hidden={!precisaSalvar}
                    disabled={isSaving || isLoadingPrazoMedio || custoChanged}
                    onClick={() => salvarValoresPrazoMedio()}
                  >
                    <span className="btn-inner--text">Salvar Informações</span>
                  </Button>
                </Col>

                <Col sm="8">
                  <div hidden={!isModoSimulacao} className="mt-3">
                    <Row>
                      <Col sm="12">
                        <h4>Modo de Simulação</h4>
                        <p>
                          Utilize os campos abaixo para simular o comportamento
                          das informações aplicando percentuais.
                          <br />
                          Se houver mudança do Custo Financeiro, o mesmo já será
                          aplicado no cálculo.
                          <br />
                          <u>
                            Essas alterações só afetarão a proposta, realmente,
                            após clicar em{' '}
                            <span className="bold">Salvar Informações</span>.
                          </u>
                        </p>
                      </Col>
                      <Col sm="6">
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText className="form-control-sm">
                              Meta Desconto (%)
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            value={metaDesconto ?? 0}
                            type="number"
                            onChange={text => {
                              const descontoUsar = Number(
                                text.target.value ?? 0,
                              );
                              setIsAtingirMeta(false);
                              setMetaDesconto(descontoUsar);
                            }}
                            disabled={isLoading}
                            className="form-control-sm"
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="primary"
                              className="btn-icon btn-2"
                              type="button"
                              outline
                              size="sm"
                              onClick={() => {
                                handleCalcularSimulador('D');
                              }}
                              disabled={isLoading}
                              title="Calcular o analisador utilizando essas informações"
                            >
                              <FaCalculator />
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>

                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText className="form-control-sm">
                              Meta Ebitda (%)
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            value={metaEbitda ?? 0}
                            type="number"
                            onChange={text => {
                              const ebitdaUsar = Number(text.target.value ?? 0);
                              setIsAtingirMeta(false);
                              setMetaEbitda(ebitdaUsar);
                            }}
                            disabled={isLoading}
                            className="form-control-sm"
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="primary"
                              className="btn-icon btn-2"
                              type="button"
                              outline
                              size="sm"
                              onClick={() => {
                                handleCalcularSimulador('E');
                              }}
                              disabled={isLoading}
                              title="Calcular o analisador utilizando essas informações"
                            >
                              <FaCalculator />
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                        <InputGroup className="mb-3">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText className="form-control-sm">
                              Meta Valor Bruto (R$)
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="text"
                            value={metaValor.replace('R$', '').trim()}
                            onBlur={text => {
                              const convertido = String(
                                text.target.value ?? '0',
                              )
                                .replaceAll('.', '')
                                .replaceAll(',', '.');
                              setMetaValor(
                                formatCurrency(Number(convertido), 2),
                              );
                            }}
                            onChange={text => {
                              const convertido = String(
                                text.target.value ?? '0',
                              )
                                .replaceAll('.', '')
                                .replaceAll(',', '.');

                              setIsAtingirMeta(true);

                              setMetaValor(convertido.replace('.', ','));
                            }}
                            disabled={isLoading}
                            className="form-control-sm"
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="primary"
                              className="btn-icon btn-2"
                              type="button"
                              outline
                              size="sm"
                              onClick={() => {
                                handleCalcularSimulador('V');
                              }}
                              disabled={isLoading}
                              title="Calcular o analisador utilizando essas informações"
                            >
                              <FaCalculator />
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </>
          )}
          <Row className="ml-0 mt-5">
            <Col sm="4">
              <Row className="ml-0">
                <h6 className="heading-small text-muted mb-1">
                  Visão Sintética
                </h6>
                {isLoadingSintetica && (
                  <CircularProgress
                    className="mt-2 ml-2"
                    color="inherit"
                    size={10}
                  />
                )}
              </Row>
              <hr className="mt-2" />

              <Table responsive bordered>
                <thead>
                  <tr>
                    <Th>Conta</Th>
                    <Th>Valores</Th>
                    <Th hidden={tabelasLimitadas}>% / ROL</Th>
                  </tr>
                </thead>
                <tbody>
                  {resultadoSintetica
                    .filter((item: ResultadoSintetica) => {
                      if (tabelasLimitadas) return item.limitar === false;
                      return true;
                    })
                    .map((sintetica, index) => {
                      const { conta, valor, percentualROL } = sintetica;

                      let color = {};
                      let fontColor = {};
                      if (conta.includes('Ebitda'))
                        color = {
                          backgroundColor: '#afe1fa',
                        };

                      if (
                        valoresDiferentes &&
                        conta.includes('Receita Bruta')
                      ) {
                        color = {
                          backgroundColor: '#EE0000',
                        };
                        fontColor = {
                          color: '#FFFFFF',
                        };
                      }

                      return (
                        <tr key={index} style={{ ...color }}>
                          <Td>
                            <Label className="pt-3 pr-4 text-muted">
                              <strong style={{ ...fontColor }}>{conta}</strong>
                            </Label>
                          </Td>
                          <Td className="text-right">
                            <Label className="pt-3 pr-4 text-muted">
                              <strong style={{ ...fontColor }}>
                                {formatCurrency(valor)}
                              </strong>
                            </Label>
                          </Td>
                          <Td className="text-right" hidden={tabelasLimitadas}>
                            <Label className="pt-3 pr-4 text-muted">
                              <strong style={{ ...fontColor }}>
                                {percentualROL} %
                              </strong>
                            </Label>
                          </Td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>

              {valoresDiferentes && (
                <Row className="mt-2">
                  <Col sm="12" xs="12">
                    <Alert color="danger">
                      O somatório das parcelas é diferente do Valor Bruto. Por
                      favor, revise-as.
                    </Alert>
                  </Col>
                </Row>
              )}
            </Col>
            {apenasSintetica === false && (
              <>
                <Col sm="8">
                  <Row className="ml-0">
                    <Col sm="6">
                      <h6 className="heading-small text-muted mb-1 ml-0">
                        Prazo Médio de Recebimento
                        {isLoadingSintetica && (
                          <CircularProgress
                            className="mt-2 ml-2"
                            color="inherit"
                            size={10}
                          />
                        )}
                      </h6>
                    </Col>
                    <Col sm="6">
                      <Button
                        size="sm"
                        className="btn-icon float-right mr-0"
                        color="warning"
                        type="button"
                        hidden={!custoChanged}
                        disabled={isSaving || isLoadingPrazoMedio}
                        onClick={recalcularCusto}
                      >
                        <span className="btn-inner--text">
                          Calcular com novo Custo Financeiro
                        </span>
                      </Button>
                    </Col>
                  </Row>
                  <hr className="mt-2" />

                  <Row
                    className="mt-1"
                    hidden={
                      !acessoProgramas.find(
                        item => item.programa === 80 && item.temAcesso === true,
                      )
                    }
                  >
                    <Col sm="3" className=" text-right">
                      <Label className="form-control-label mt-3">
                        Data Embarque:
                      </Label>
                    </Col>
                    <Col sm="4">
                      <DatePicker
                        locale="pt-BR"
                        dateFormat="dd/MM/yyyy"
                        showIcon
                        disabled={
                          !acessoProgramas.find(
                            item =>
                              item.programa === 80 &&
                              item.temAcesso === true &&
                              item.acessoLimitado === false,
                          )
                        }
                        selected={dataEmbarque}
                        onChange={event =>
                          atualizarDados('data_embarque', event)
                        }
                      />
                    </Col>
                    <Col sm="4">
                      <Label className="form-control-label mt-3">
                        {diasParaEmbarque} dias
                      </Label>
                    </Col>
                  </Row>

                  <Row
                    className="mt-1"
                    hidden={
                      !acessoProgramas.find(
                        item => item.programa === 82 && item.temAcesso === true,
                      )
                    }
                  >
                    <Col sm="3" className=" text-right">
                      <Label className="form-control-label mt-3">
                        Data Base Juros:
                      </Label>
                    </Col>
                    <Col sm="2">
                      <Label className="form-control-label mt-3">
                        {dataBaseJurosEmbarque}
                      </Label>
                    </Col>
                    <Col sm="2">
                      <Input
                        type="number"
                        value={diasAntesEmbarque ?? 0}
                        onChange={event =>
                          atualizarDados(
                            'dias_antes_embarque',
                            event.target.value,
                          )
                        }
                        hidden={
                          !acessoProgramas.find(
                            item =>
                              item.programa === 82 &&
                              item.temAcesso === true &&
                              item.acessoLimitado === false,
                          )
                        }
                      />
                    </Col>
                    <Col sm="4">
                      <Label className="form-control-label mt-3">
                        <small>(dias antes embarque)</small>
                      </Label>
                    </Col>
                  </Row>

                  <Row
                    className="mt-1"
                    hidden={
                      !acessoProgramas.find(
                        item => item.programa === 81 && item.temAcesso === true,
                      )
                    }
                  >
                    <Col sm="3" className=" text-right" />
                    <Col sm="4">
                      <Input
                        type="number"
                        value={jurosMensal ?? 0}
                        onChange={event =>
                          atualizarDados('juros_mensal', event.target.value)
                        }
                        disabled={
                          !acessoProgramas.find(
                            item =>
                              item.programa === 81 &&
                              item.temAcesso === true &&
                              item.acessoLimitado === false,
                          )
                        }
                      />
                    </Col>
                    <Col sm="4">
                      <Label className="form-control-label mt-3">
                        <small>Juros a.m. (a partir da data base)</small>
                      </Label>
                    </Col>
                  </Row>

                  <Row className="mt-1">
                    <Col sm="3" className=" text-right" />
                    <Col sm="4">
                      <Label className="form-control-label mt-3">
                        {`${custoFinanceiro}%`}
                      </Label>
                    </Col>
                    <Col sm="4">
                      <Label className="form-control-label mt-3">
                        <small>Custo financeiro no período</small>
                      </Label>
                    </Col>
                  </Row>

                  <Row className="mt-1">
                    <Col sm="3" className=" text-right" />
                    <Col sm="8">
                      <Label className="form-control-label mt-3">
                        <strong>PMR:</strong> {PMR} dias da data base
                      </Label>
                    </Col>
                  </Row>

                  <Row>
                    {informacaoProposta && (
                      <Parcelas
                        propostaVersao={informacaoProposta}
                        isModoSimulacao={isModoSimulacao}
                        onChange={handleChange}
                        isAnalisador
                        setCustoChanged={setCustoChanged}
                      />
                    )}
                  </Row>

                  <Row>{/* criarTabela(propostaVersaoParcelas) */}</Row>
                </Col>
              </>
            )}
          </Row>
          {/* {apenasSintetica === true && */}
          <>
            <Row className="ml-0 mt-5">
              <h6 className="heading-small text-muted mb-1">Visão Analítica</h6>
              {isLoadingAnalitica && (
                <CircularProgress
                  className="mt-2 ml-2"
                  color="inherit"
                  size={10}
                />
              )}
            </Row>
            <hr className="mt-2" />

            <Table responsive bordered>
              <thead>
                <tr>
                  <Th>Item</Th>
                  <Th>Valores</Th>
                  <Th hidden={tabelasLimitadas}>% / ROL</Th>
                  <Th hidden={tabelasLimitadas}>% / ROB</Th>
                </tr>
              </thead>
              <tbody>
                {resultadoAnalitica
                  .filter((item: ResultadoAnalitica) => {
                    if (tabelasLimitadas) return item.limitar === false;
                    return true;
                  })
                  .map((analitica, index) => {
                    const { item, valor, percentualROL, percentualROB } =
                      analitica;

                    return (
                      <tr key={index}>
                        <Td>
                          <Label className="pt-3 pr-4 text-muted">
                            <strong>{item}</strong>
                          </Label>
                        </Td>
                        <Td className="text-right">
                          <Label className="pt-3 pr-4 text-muted">
                            <strong>{formatCurrency(valor)}</strong>
                          </Label>
                        </Td>
                        <Td className="text-right" hidden={tabelasLimitadas}>
                          <Label className="pt-3 pr-4 text-muted">
                            <strong>{percentualROL} %</strong>
                          </Label>
                        </Td>
                        <Td className="text-right" hidden={tabelasLimitadas}>
                          <Label className="pt-3 pr-4 text-muted">
                            <strong>{percentualROB} %</strong>
                          </Label>
                        </Td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>

            <Row className="ml-0 mt-5">
              <h6 className="heading-small text-muted mb-1">
                Abertura de Preço por Atividade
              </h6>
              {isLoadingAtividade && (
                <CircularProgress
                  className="mt-2 ml-2"
                  color="inherit"
                  size={10}
                />
              )}
            </Row>
            <hr className="mt-2" />

            <Table responsive bordered>
              <thead>
                <tr>
                  <Th>Atividade</Th>
                  <Th>Descrição Atividade</Th>
                  <Th>BDI Total</Th>
                  <Th style={{ backgroundColor: '#17446B', color: '#FFFFFF' }}>
                    Receita Bruta
                  </Th>
                  <Th
                    hidden={tabelasLimitadas}
                    style={{ backgroundColor: '#17446B', color: '#FFFFFF' }}
                  >
                    Preço Líquido
                  </Th>
                  <Th hidden={tabelasLimitadas}>Custo Materiais</Th>
                  <Th hidden={tabelasLimitadas}>% / ROL</Th>
                  <Th hidden={tabelasLimitadas}>Demais CVs</Th>
                  <Th
                    hidden={tabelasLimitadas}
                    style={{ backgroundColor: '#2068A9', color: '#FFFFFF' }}
                  >
                    Margem Cont
                  </Th>
                  <Th
                    hidden={tabelasLimitadas}
                    style={{ backgroundColor: '#2068A9', color: '#FFFFFF' }}
                  >
                    % MC / ROL
                  </Th>
                  <Th hidden={tabelasLimitadas}>% ABC Fat</Th>
                </tr>
              </thead>
              <tbody>
                {(Array.isArray(resultadoAtividade)
                  ? resultadoAtividade
                  : []
                ).map((atividade, index) => {
                  const {
                    codigoAtividade,
                    descricaoAtividade,
                    bdiTotal,
                    precoBruto,
                    precoLiquido,
                    custoMateriais,
                    percentualROL,
                    demaisCV,
                    margemCont,
                    percentualMargemROL,
                    abcFat,
                    isTotalRow,
                  } = atividade;

                  const fontWeight = isTotalRow ? 850 : 'normal';
                  return (
                    <tr key={index}>
                      <Td>
                        <Label className="pt-3 pr-4 text-muted">
                          <strong>{codigoAtividade}</strong>
                        </Label>
                      </Td>
                      <Td>
                        <Label className="pt-3 pr-4 text-muted">
                          <strong style={{ fontWeight }}>
                            {descricaoAtividade}
                          </strong>
                        </Label>
                      </Td>
                      <Td className="text-right">
                        <Label className="pt-3 pr-4 text-muted">
                          <strong style={{ fontWeight }}>
                            {formatCurrency(bdiTotal)}
                          </strong>
                        </Label>
                      </Td>
                      <Td
                        className="text-right"
                        style={{ backgroundColor: '#17446B' }}
                      >
                        <Label className="pt-3 pr-4 text-muted">
                          <strong style={{ color: '#FFFFFF', fontWeight }}>
                            {formatCurrency(precoBruto)}
                          </strong>
                        </Label>
                      </Td>
                      <Td
                        hidden={tabelasLimitadas}
                        className="text-right"
                        style={{ backgroundColor: '#17446B' }}
                      >
                        <Label className="pt-3 pr-4 text-muted">
                          <strong style={{ color: '#FFFFFF', fontWeight }}>
                            {formatCurrency(precoLiquido)}
                          </strong>
                        </Label>
                      </Td>
                      <Td hidden={tabelasLimitadas} className="text-right">
                        <Label className="pt-3 pr-4 text-muted">
                          <strong style={{ fontWeight }}>
                            {formatCurrency(custoMateriais)}
                          </strong>
                        </Label>
                      </Td>
                      <Td hidden={tabelasLimitadas} className="text-right">
                        <Label className="pt-3 pr-4 text-muted">
                          <strong style={{ fontWeight }}>
                            {percentualROL} %
                          </strong>
                        </Label>
                      </Td>
                      <Td hidden={tabelasLimitadas} className="text-right">
                        <Label className="pt-3 pr-4 text-muted">
                          <strong style={{ fontWeight }}>
                            {formatCurrency(demaisCV)}
                          </strong>
                        </Label>
                      </Td>
                      <Td
                        hidden={tabelasLimitadas}
                        className="text-right"
                        style={{ backgroundColor: '#2068A9' }}
                      >
                        <Label className="pt-3 pr-4 text-muted">
                          <strong style={{ fontWeight, color: '#FFFFFF' }}>
                            {formatCurrency(margemCont)}
                          </strong>
                        </Label>
                      </Td>
                      <Td
                        hidden={tabelasLimitadas}
                        className="text-right"
                        style={{ backgroundColor: '#2068A9' }}
                      >
                        <Label className="pt-3 pr-4 text-muted">
                          <strong style={{ fontWeight, color: '#FFFFFF' }}>
                            {percentualMargemROL} %
                          </strong>
                        </Label>
                      </Td>
                      <Td hidden={tabelasLimitadas} className="text-right">
                        <Label className="pt-3 pr-4 text-muted">
                          <strong style={{ fontWeight }}>{abcFat} %</strong>
                        </Label>
                      </Td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </>
          {/* } */}
        </CardBody>
      </Card>
    </>
  );
}
